import { MenuItem, Popper } from '@mui/material';
import { MutableRefObject } from 'react';
import { MigrationStatus } from '@src/constants/MigrationStatus';
import { useSaveMigrationStatusLazy } from '@src/adapters/hooks/migration/useSaveMigrationStatus';
import ArrowDropDownIcon from '@mui/icons-material/Check';
interface Props {
  close(status: MigrationStatus): void;
  open: boolean;
  anchorEl?: MutableRefObject<null> | null;
  migrationId: string;
  currentStatus: MigrationStatus;
}

function MigrationStatusSelection({
  close,
  open,
  anchorEl,
  migrationId,
  currentStatus,
}: Props) {
  const { execute } = useSaveMigrationStatusLazy();

  const handleClick = async (status: MigrationStatus) => {
    await execute({
      id: migrationId,
      status: status,
    });

    close(status);
  };

  return (
    <Popper
      open={open}
      aria-labelledby="Migration status"
      aria-describedby="Migration status"
      disablePortal
      placement="bottom-start"
      anchorEl={anchorEl ? anchorEl?.current : null}
      sx={{
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '20px',
        '& .MuiPopover-paper': {
          width: 200,
        },
      }}>
      <MenuItem
        onClick={() => handleClick(MigrationStatus.Pending)}
        selected={currentStatus === MigrationStatus.Pending}>
        Pending
        {currentStatus === MigrationStatus.Pending && <ArrowDropDownIcon />}
      </MenuItem>
      <MenuItem
        onClick={() => handleClick(MigrationStatus.InProgress)}
        selected={currentStatus === MigrationStatus.InProgress}>
        In Progress
        {currentStatus === MigrationStatus.InProgress && <ArrowDropDownIcon />}
      </MenuItem>
      <MenuItem
        onClick={() => handleClick(MigrationStatus.Query)}
        selected={currentStatus === MigrationStatus.Query}>
        Query
      </MenuItem>
    </Popper>
  );
}

export default MigrationStatusSelection;
